import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.post('/customer-api/company-relation/relation/page', params)

// 删除
export const removeItem = id =>
  request.get(`/customer-api/company-relation/relation/delete/${id}`)

// 新增
export const add = params =>
  request.post('/customer-api/company-relation/relation/add', params)
